import { type CompanyOption } from '../types.ts';

export const mergePopulatedValue = (populatedOptions: CompanyOption[], options: CompanyOption[]) =>
  options.map(option => {
    const populatedOption = populatedOptions.find(populatedOpt => populatedOpt.id === option.id);

    if (populatedOption) {
      return {
        ...option,
        ...populatedOption,
      };
    }

    return option;
  });
